import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { events } from '../analytics';
import { SEOHead } from '../components/SEOHead';
import {
    StoriesPageContainer,
    StoriesGrid,
    StoryCard,
    StoryImage,
    StoryContent,
    StoryTitle,
    StoryExcerpt,
    ViewButton,
    ModalOverlay,
    ModalContainer,
    ModalCloseButton,
    ModalImage,
    ModalContent,
    ModalTitle,
    ModalFullStory
} from './StoriesPage.styled';
import { SectionTitle } from './ContactPage.styled';
import history1 from '../assets/images/stories/story-1.png';
import history2 from '../assets/images/stories/story-2.png';
import history3 from '../assets/images/stories/story-3.png';
import history4 from '../assets/images/stories/story-4v1.png';
import history5 from '../assets/images/stories/story-5.png';
import history6 from '../assets/images/stories/story-6.png';
// Datos de ejemplo para las historias
const storiesData = [
    {
        id: 1,
        title: "El Hilo que Une Corazones",
        excerpt: "¿Cómo agradecer a quien siembra conocimiento cada día? Acompáñanos a descubrir la historia detrás de una totebag creada con hilos de gratitud y de admiración para una maestra inolvidable.",
        fullStory: `Todo comenzó con un mensaje lleno de cariño en nuestro WhatsApp. Una madre nos contactó con un deseo especial: quería un regalo que no fuera solo un objeto, sino un abrazo tangible para la maestra de su hija. Alguien que, más allá de los libros, enseña con el corazón.

Nos pusimos manos a la obra en el taller de Duo a Color. Elegimos la técnica de punch needle para darle relieve y textura a una vibrante flor hierbera roja, símbolo de la fuerza y la pasión que florece en un salón de clases. Cada puntada fue un reconocimiento a la paciencia de esa docente. Luego, con pincel en mano, trazamos la frase que lo resumía todo: "Esta maestra enseña con el corazón".

Mientras aplicábamos los detalles finales y preparábamos nuestro empaquetado único, no podíamos dejar de pensar en el momento en que esa maestra abriría su regalo. Al final, esta totebag no solo llevará cuadernos o lápices; llevará el reconocimiento de una familia que valora la huella que ella deja en el futuro de un niño. En Duo a Color, no solo unimos hilos, tejemos historias que merecen ser contadas.`,
        imageUrl: history1
    },
    {
        id: 2,
        title: "El Mapa de un Corazón Majorero",
        excerpt: "¿Se puede capturar toda una vida en una sola inicial? Descubre cómo transformamos la pasión por la enfermería y el amor infinito por las olas de Fuerteventura en una pieza de arte táctil y única.",
        fullStory: `Hay pedidos que son un verdadero reto creativo y este nos emocionó desde el primer mensaje. Un chico quería hacerle un regalo inolvidable a una amiga; una mujer cuya vida late entre la entrega absoluta de su profesión como enfermera y la paz que solo le regala su isla, Fuerteventura.

Buscábamos algo que ella pudiera usar a diario, así que el lienzo elegido fue una de nuestras totebags. El diseño central nació de su inicial, una "S", pero trabajada con un relieve especial en punch needle que le da esa textura de peluche tan suave al tacto. Dentro de esa letra, fuimos tejiendo con precisión quirúrgica cada trocito de su alma: un estetoscopio y una curita que representan su orgullo de cuidar a los demás; y bajo el sol radiante, una palmera, una tortuga de agua y la silueta de su amada isla rodeada por las olas del mar.

El resultado es una explosión de texturas y colores que representan su mundo. Ahora, ella no solo lleva una bolsa al hospital o a sus paseos por la isla; lleva una pieza de arte textil creada exclusivamente para ella. En Duo a Color, demostramos que con paciencia y nuestra técnica de punch needle, podemos convertir cualquier sentimiento en una textura que puedes llevar contigo.`,
        imageUrl: history2
    },
    {
        id: 3,
        title: "La Melodía de un Nuevo Comienzo",
        excerpt: "¿Cómo suena el agradecimiento de un alumno que se despide de su infancia? Descubre la historia detrás de este cojín, un regalo tejido con gratitud para la maestra que puso música a los últimos pasos antes de la ESO.",
        fullStory: `El último año de colegio es una mezcla de nervios, emoción y cambios. Para un alumno de sexto grado, es el cierre de una etapa llena de juegos para dar el gran salto hacia la ESO. En medio de ese torbellino de emociones de pre-adolescente, surgió un deseo sincero: darle las gracias a su tutora y profesora de música por haber sido su guía y su apoyo en este viaje.

En Duo a Color, aceptamos el reto de convertir esa gratitud en algo que ella pudiera abrazar. Creamos un cojín blanco puro donde la técnica del punch needle permitió que la música cobrara vida propia. El corazón del diseño es una elegante clave de sol de la que brotan flores coloridas, simbolizando cómo su enseñanza hizo florecer la creatividad en el aula. A su alrededor, pequeñas notas musicales parecen bailar, celebrando cada lección compartida.

Cada puntada de este bordado 100% artesanal lleva el cariño de un alumno que no quería irse sin decirle a su maestra que su dedicación dejó una huella imborrable. Ahora, en su rincón favorito, este cojín será el recordatorio de que, aunque los ciclos terminen, las buenas melodías permanecen para siempre. En Duo a Color, tejemos los recuerdos que marcan los momentos más importantes de tu vida.`,
        imageUrl: history3
    },
    {
        id: 4,
        title: "El Relieve de la Amistad: Tres Historias Tejidas a Mano",
        excerpt: "¿Es posible definir una personalidad solo con texturas? Acompáñanos a descubrir cómo transformamos el hilo en emociones para crear tres piezas únicas donde el punch needle es el protagonista absoluto.",
        fullStory: `A veces, el reto no está en el color, sino en la textura. Recibimos un pedido muy especial: tres neceseres que debían ser el espejo de tres personalidades vibrantes. En esta ocasión, decidimos que cada puntada de punch needle llevara todo el peso de la historia, creando relieves que dan ganas de tocar una y otra vez.

Para Andrea, el lienzo negro se convirtió en un refugio para Bella. Ella es el reflejo de un corazón soñador y una mente que se apasiona con la lectura. Queríamos que su valentía se sintiera al tacto, por eso trabajamos cada bucle con precisión para darle ese acabado clásico y atemporal que solo un detalle artesanal puede transmitir.

Noelia, por su parte, es pura energía y humor. Para ella, el elegido fue el Grinch. Capturar su gesto icónico y ese verde eléctrico usando exclusivamente la técnica de aguja mágica fue un proceso increíble. El resultado es una pieza con un relieve rebelde y divertido, justo como la personalidad brillante de Noelia, que siempre sabe sacarnos una sonrisa con su ingenio.

Y para cerrar este trío perfecto, llegó Stitch para Valeria. Con sus enormes orejas azules sobresaliendo del diseño, esta pieza simboliza su lealtad incondicional y ese espíritu travieso que la hace tan especial. Es un diseño lleno de volumen que representa a la perfección a esa amiga que siempre está ahí, siendo fiel a su estilo único.

En Duo a Color, nos apasiona demostrar que con el punch needle podemos ir más allá de un dibujo: creamos piezas con dimensión y alma. Ver estos tres neceseres terminados nos confirma que, cuando se trabaja con paciencia y corazón, el hilo se convierte en el lenguaje perfecto para celebrar la amistad.`,
        imageUrl: history4
    },
    {
        id: 5,
        title: "Una Receta de Hilo y Color: El Festín de la Come Galletas",
        excerpt: "¿Qué pasa cuando unes la pasión por la repostería con el arte textil? Descubre cómo horneamos una pieza única que combina pintura y punch needle para la fan número uno del Monstruo de las Galletas.",
        fullStory: `Hay pasiones que se llevan en el corazón, ¡y otras que se llevan puestas! Cuando nuestra clienta nos contó su amor por el Monstruo de las Galletas, supimos que un diseño convencional no sería suficiente. Ella necesitaba algo que tuviera tanta textura y sabor como sus propias recetas.

Para este reto, decidimos utilizar todo nuestro arsenal creativo: una combinación perfecta de pintura y punch needle. En su nueva ToteBag y su delantal personalizado, cada galleta fue pintada a mano, cuidando cada detalle para que parecieran recién salidas del horno. Pero el verdadero protagonista es Lucas: trabajamos su rostro con la técnica de aguja mágica para lograr ese relieve azul tan suave y esponjoso que dan ganas de abrazarlo.

El resultado es una explosión de contrastes. Mientras la pintura nos da la precisión de las chispas de chocolate, el punch needle aporta esa dimensión táctil que convierte una prenda de trabajo en una pieza de colección. Ver su cara de sorpresa al recibirlo es la mejor recompensa; ahora, cada vez que hornee, no solo llevará un delantal, llevará una obra de arte creada especialmente para su mundo de galletas.

En Duo a Color, creemos que los objetos que usamos a diario deben hacernos sonreír. Mezclando texturas y colores, logramos que lo artesanal cuente tu historia favorita.`,
        imageUrl: history5
    },
    {
        id: 6,
        title: "Más allá de la Tierra: El Renacer de las CrazyPlantPots",
        excerpt: "¿Cómo transformar una pasión por la tradición en un rincón lleno de color? Descubre la historia de una clienta que soñaba con llevar la esencia de las catrinas a su hogar a través de piezas únicas en cemento y barro.",
        fullStory: `Todo comenzó con una conversación muy especial. Una clienta se acercó a nosotros compartiendo su fascinación por la estética de las "calaquitas" y las catrinas; buscaba algo que reflejara ese amor por la tradición mexicana, pero con un toque moderno y artesanal que solo pudiera encontrar en DuoaColor.

Nos pusimos manos a la obra con dos proyectos paralelos para cumplir su deseo. Primero, preparamos en nuestro taller el vaciado de una calavera en cemento blanco. Queríamos que fuera una pieza con fuerza, así que tras el desmoldado, aplicamos colores púrpuras y detalles geométricos que le dieron esa personalidad vibrante que ella buscaba. Para complementar el set, tomamos una maceta de barro clásica y la convertimos en un lienzo para una Catrina de estilo libre, donde las flores y los trazos pintados a mano celebran la vida en cada centímetro.

Al ver las piezas terminadas, supimos que habíamos logrado capturar su esencia. Ahora, sus plantas no solo tienen un hogar, sino que ella tiene un pequeño altar artístico que cuenta su propia historia de admiración por esta cultura. En Duo a Color, no solo pintamos macetas; transformamos las pasiones de nuestros clientes en objetos tangibles que llenan de alma cualquier espacio.`,
        imageUrl: history6
    }
];


function StoriesPage() {
    const [selectedStory, setSelectedStory] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const modalRef = useRef(null);
    const closeButtonRef = useRef(null);

    const handleOpenModal = (story) => {
        setSelectedStory(story);
        setIsModalOpen(true);
        // Bloquear scroll del body cuando el modal está abierto
        document.body.style.overflow = 'hidden';
        // Trackear apertura de historia en GA4
        events.storyOpen(story.title);
        // Enfocar el botón de cerrar cuando se abre el modal
        setTimeout(() => {
            if (closeButtonRef.current) {
                closeButtonRef.current.focus();
            }
        }, 100);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        // Restaurar scroll del body
        document.body.style.overflow = 'unset';

        // Pequeño delay para la animación de salida
        setTimeout(() => {
            setSelectedStory(null);
        }, 300);
    };

    // Cerrar modal con ESC
    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape' && isModalOpen) {
                handleCloseModal();
            }
        };

        document.addEventListener('keydown', handleEscKey);
        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [isModalOpen]);

    // Click fuera del modal para cerrar
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                modalRef.current &&
                !modalRef.current.contains(event.target) &&
                isModalOpen &&
                !event.target.closest('.story-card') // Evitar que cierre al hacer clic en las tarjetas
            ) {
                handleCloseModal();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isModalOpen]);

    // Prevenir scroll cuando el modal está abierto
    useEffect(() => {
        if (isModalOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isModalOpen]);

    return (
        <StoriesPageContainer>
            <SEOHead
                title="Historias Vividas - Duo a Color Creaciones"
                description="Descubre las creaciones de Duo a Color (duoacolor). Cada pieza de punch needle cuenta una historia única. Diseños artesanales personalizados en España."
                path="/lived-stories"
            />
            <SectionTitle>Historias Vividas</SectionTitle>

            <StoriesGrid>
                {storiesData.map((story) => (
                    <StoryCard
                        key={story.id}
                        className="story-card"
                        onClick={() => handleOpenModal(story)}
                        role="button"
                        tabIndex={0}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                handleOpenModal(story);
                            }
                        }}
                    >
                        <StoryImage>
                            <img
                                src={story.imageUrl}
                                alt={story.title}
                                loading="lazy"
                            />
                        </StoryImage>
                        <StoryContent>
                            <StoryTitle>{story.title}</StoryTitle>
                            <StoryExcerpt>{story.excerpt}</StoryExcerpt>
                            <ViewButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenModal(story);
                                }}
                                aria-label={`Ver historia completa: ${story.title}`}
                            >
                                Ver Historia Completa
                            </ViewButton>
                        </StoryContent>
                    </StoryCard>
                ))}
            </StoriesGrid>

            {/* Modal renderizado con Portal para estar fuera del stacking context */}
            {selectedStory && ReactDOM.createPortal(
                <ModalOverlay
                    isOpen={isModalOpen}
                    onClick={handleCloseModal}
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modal-title"
                >
                    <ModalCloseButton
                        ref={closeButtonRef}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleCloseModal();
                        }}
                        aria-label="Cerrar modal"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                handleCloseModal();
                            }
                        }}
                    >
                        ×
                    </ModalCloseButton>

                    <ModalContainer
                        ref={modalRef}
                        isOpen={isModalOpen}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <ModalImage>
                            <img
                                src={selectedStory.imageUrl}
                                alt={selectedStory.title}
                            />
                        </ModalImage>

                        <ModalContent>
                            <ModalTitle id="modal-title">{selectedStory.title}</ModalTitle>
                            <ModalFullStory>
                                {selectedStory.fullStory.split('\n\n').map((paragraph, index) => (
                                    <p key={index}>{paragraph}</p>
                                ))}
                            </ModalFullStory>
                        </ModalContent>
                    </ModalContainer>
                </ModalOverlay>,
                document.getElementById('modal-root')
            )}
        </StoriesPageContainer>
    );
}

export default StoriesPage;